<template>
 <div class="footer">
    <div>主办：江苏省政务服务管理办公室 版权所有</div>
    <div>运行管理：江苏省政务服务管理办公室</div>
    <div class="put">备案序号：苏ICP备15009401号</div>
    <div>网站标识：3200000098</div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.footer {
  height: 67px;
  line-height: 67px;
  background: #EAEBEB;
  color: #333;
  font-size: 18px;
  text-align: center;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  display: flex;
  justify-content: center;
  div{
    margin: 0 20px;
  }
  .put{
    color: #0786FE;
  }
}
</style>